import api from '../api';
import { getCurrentLanguage } from '../i18n';

const qophService = {
  listChats: async () => {
    return api.get('/qoph');
  },
  createChat: async (message) => {
    const lang = getCurrentLanguage();
    return api.post('/qoph', { message, lang, translateTo: lang });
  },
  getChatMessages: async (id) => {
    return api.get(`/qoph/${id}/messages`);
  },
  sendMessage: async (id, message) => {
    const lang = getCurrentLanguage();
    return api.post(`/qoph/${id}/messages`, { message, lang, translateTo: lang });
  },
  updateChat: async (id, title) => {
    return api.put(`/qoph/${id}`, { title });
  },
  deleteChat: async (id) => {
    return api.delete(`/qoph/${id}`);
  }
};

export default qophService;
